import { FC, useState } from "react";
import { TaskStatus } from "tm-shared/types";

import { COMMENT_OPTIONS } from "@/constants/ui/comment";
import { AppSelect } from "@/shared/forms/AppSelect";
import { AppTextArea } from "@/shared/forms/AppTextArea";
import { BaseModal } from "@/shared/ui/BaseModal";

interface CommentModalProps {
    onCloseModal: () => void;
    onConfirm: (newComment: string) => void;
    initialComment: string;
    taskStatus?: TaskStatus;
}

export const CommentModal: FC<CommentModalProps> = ({
    onCloseModal,
    onConfirm,
    initialComment,
    taskStatus,
}) => {
    const [localComment, setLocalComment] = useState(initialComment);

    const handleChange = (value: string) => {
        const currentOptionComment = COMMENT_OPTIONS.find(
            (option) => option.value === value,
        ) ?? { label: "" };

        setLocalComment(currentOptionComment.label);
    };

    const handleConfirm = () => {
        onConfirm(localComment);
        onCloseModal();
    };

    return (
        <BaseModal
            open
            onClose={onCloseModal}
            title={"Залиште коментар"}
            confirmText="Зберегти"
            onConfirm={handleConfirm}
        >
            {taskStatus === TaskStatus.Rejected ? (
                <AppSelect
                    onChange={handleChange}
                    placeholder="Залиште коментар"
                    options={COMMENT_OPTIONS}
                    defaultValue={COMMENT_OPTIONS.find(
                        (option) => option.label === initialComment,
                    )}
                    size="large"
                />
            ) : (
                <AppTextArea
                    autoSize={{ minRows: 5, maxRows: 10 }}
                    value={localComment}
                    placeholder="Ваш коментар..."
                    onChange={(event) => setLocalComment(event.target.value)}
                />
            )}
        </BaseModal>
    );
};
